// extracted by mini-css-extract-plugin
module.exports = {"mobileTxCheckMessages":"styles_mobileTxCheckMessages__xdOqa"};